import React, { useEffect, useState } from "react";
import { MapPin, CalendarDays } from "lucide-react";
import { statusColor } from "../lib/provinces";
import { titleCase, formatDateID } from "../lib/format";

export const IssueTrending = ({ issues = [] }) => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (issues.length === 0) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % Math.min(10, issues.length)), 6000);
    return () => clearInterval(t);
  }, [issues.length]);

  const top = issues.slice(0, 10);
  const item = top[idx];

  return (
    <div className="nms-card right-card issue-card" data-testid="issue-trending-card">
      <div className="ic-eyebrow">
        <span>TODAY MONITORING</span>
        <span className="ic-top10">TOP 10</span>
      </div>
      <h3 className="ic-title">ISSUE TRENDING</h3>

      {item && (
        <div className="ic-body" data-testid="issue-trending-item">
          <div className="ic-big-number">#{idx + 1}</div>
          <div className="ic-meta">
            <span className="ic-loc">
              <MapPin size={11} /> {item.province}
            </span>
            <span className="ic-date">
              <CalendarDays size={11} /> {formatDateID(item.date)}
            </span>
          </div>
          <div className="ic-headline">{titleCase(item.title)}</div>
          <div className="ic-foot">
            <span
              className="ic-status"
              style={{ borderColor: statusColor(item.status), color: statusColor(item.status) }}
            >
              ● {item.status?.toUpperCase()}
            </span>
            <span className="ic-pct">Coverage {(item.percentage ?? 0).toFixed(1)}%</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default IssueTrending;
